function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16,1.128c8.222,0 14.897,6.675 14.897,14.897c0,8.222 -6.675,14.897 -14.897,14.897c-8.222,0 -14.897,-6.675 -14.897,-14.897c-0,-8.222 6.675,-14.897 14.897,-14.897Zm0,2.98c-6.577,0 -11.917,5.34 -11.917,11.917c0,6.577 5.34,11.917 11.917,11.917c6.577,0 11.917,-5.34 11.917,-11.917c0,-6.577 -5.34,-11.917 -11.917,-11.917Z"
});
var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 11.122,
  cy: 10.124,
  r: 1.843
});
var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 20.892,
  cy: 10.124,
  r: 1.843
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M22.382,22.357c0,0.822 -0.668,1.49 -1.49,1.49c-0.822,0 -1.49,-0.668 -1.49,-1.49c0,-0.683 -0.357,-1.185 -0.866,-1.526c-0.688,-0.461 -1.611,-0.669 -2.529,-0.669c-0.917,0 -1.841,0.208 -2.529,0.669c-0.509,0.341 -0.866,0.844 -0.866,1.526c0,0.822 -0.668,1.49 -1.49,1.49c-0.822,0 -1.49,-0.668 -1.49,-1.49c0,-3.297 3.098,-5.175 6.375,-5.175c3.278,0 6.375,1.879 6.375,5.175Z"
});
var SvgSad = function SvgSad(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, ["svgRef"]);
  return React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSad, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sad.d192a5f9.svg";
export { ForwardRef as ReactComponent };